import axios from '~/util/axios'

export default {
  shareAppBySms (phone, code) {
    var postData = `code=${code}&input[phone_number]=${phone}&input[access_code]=${code}`
    return axios.get('/install/send_sms?' + postData, {})
  }
}
